import React from "react";
import {
  SEO,
  Image,
  MarkdownContent,
  SlideReveal,
  multipleComponentIterator,
  BackgroundImageTeamMember,
  InternalLink,
} from "@bluefin/components";
import { Grid, Segment, Header, Button, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";
import { createTeamMemberSlug } from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class BeautyCollectivePage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      allFishermanBusinessTeam,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.aehairandco.com/beauty-collective/"}
        />
        <Grid
          className={"custom-page-beauty-collective custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"fjcmklkigmgkepoa full-width"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={1}
          >
            <Grid.Column className={"cidjdfhceoifeikl"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "580px" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "3257359b-cd24-4a70-8dd5-a7ed00645252",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.30)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "e7d15a04-5196-4a9d-bcb9-2be3113c3c9c",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"akpgfolmobllefbj"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"ceodopjdkcaeekde"}
              style={{ padding: 16 }}
              width={7}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "400px", objectFit: "contain" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "0989e827-c43a-4943-b54c-794939103da6",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"naccejhmpaijechi"}
              style={{ padding: 16 }}
              width={1}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <div className={""} style={{}} />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"pkbnmmkpnokceikg"}
              style={{ padding: 16 }}
              width={7}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "75f0489a-0b08-4d8f-aa9a-499647a26423",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"aepocmfnjaehekkb"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"nplbkdanaicaeena"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__fd54cf29-3149-40e4-ab07-3d7ed8de400e"}
                >
                  <div className={"about-page"}>
                    <Grid
                      stackable={true}
                      textAlign={"center"}
                      className={"about-staff-container"}
                    >
                      <Grid.Column width={16} textAlign={"center"}>
                        <Header
                          as={"h2"}
                          className={"about-staff-header"}
                          content={"Our Team"}
                        />
                        <Card.Group
                          className={"about-featured-staff stylists"}
                          itemsPerRow={3}
                        >
                          <SlideReveal
                            cascade={true}
                            triggerOnce={true}
                            className={"ui card"}
                            fade={true}
                            direction={"up"}
                            children={multipleComponentIterator({
                              iterator: allFishermanBusinessTeam.nodes,
                              limit: 3,
                              components: [
                                {
                                  propMap: {
                                    to: createTeamMemberSlug,
                                    key: "_id",
                                    "teamMember.name": "name",
                                    "teamMember.role": "role",
                                    "teamMember.email": "email",
                                    "teamMember.hours": "hours",
                                    "teamMember.phone": "phone",
                                    "teamMember.photo": "gatsbyImage",
                                    "teamMember.locations": "locations",
                                    "teamMember.description": "description",
                                  },
                                  component: (
                                    <BackgroundImageTeamMember
                                      useModal={false}
                                      as={InternalLink}
                                    />
                                  ),
                                },
                              ],
                            })}
                          />
                        </Card.Group>
                        <Button to={"/team/"} primary={true} as={InternalLink}>
                          See All Stylists
                        </Button>
                      </Grid.Column>
                    </Grid>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fbkiohggammceoak"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"jopjmhihiimdebig"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "14bd2c89-bdf8-4cb8-a130-346bf73b8969",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"cekjoooekcngenmf"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"kiggfkifilhjeofi"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "d03845fa-b624-426f-aa4a-c1d792fbcb81",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"mapkhbklaiidedai"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"momgacacajdneblp"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__f461c085-2e89-42b4-866d-b11ef061ed06"}
                >
                  <div
                    className={
                      "elfsight-app-c5f294a6-3ff5-4424-a7f1-f57a0ae5d1e2"
                    }
                    data-elfsight-app-lazy={true}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 35872 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        show
        email
        group
        hours {
          openTime
          startDay
          closeTime
        }
        image
        phone
        locations {
          _id
          name
        }
        description
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          url
          platform
        }
      }
    }
  }
`;
